    <template>
    <div class="app_content">
      <div class="header_login">
        <div class="header_inner">
          <el-col :span="8"><router-link :to="{ path: '/' }" class="logo">普惠</router-link></el-col>
          <el-col :span="16" class="login_side_nav">
            <a @click="gobackFirstPage">返回首页</a>
            <em></em>
            <router-link :to="{path:'login'}"><span>已有账号？立即登录</span></router-link>
          </el-col>
        </div>
      </div><!-- header END -->
	<!-- forgetpwd -->
	<div class="forgetpwd">
    <el-form ref="form" :model="form" :rules="forgetPasswordRules">
	      <h3 class="title_regist">找回密码</h3>
	      <el-row class="inputs">
	        <el-col :span="16">
            <el-form-item label="手机号:" prop="phoneNumber" labelWidth="400px">
                <el-input v-model="form.phoneNumber" placeholder="请输入手机号"></el-input>
            </el-form-item>
	        </el-col>
	      </el-row>
	      <el-row class="inputs">
	        <el-col :span="16">
            <el-form-item label="验证码:" prop="phoneCaptcha" labelWidth="400px">
            <el-input  v-model="form.phoneCaptcha" placeholder="短信验证码" class="m_input input_msgcode"></el-input>
                <el-button type="default" class="btn_login_msg" v-bind:class="{transparent:showCaptchaCodeButton}" @click="getForgetPwdCaptcha"> {{btntxt}}</el-button>
            </el-form-item>
	        </el-col>
	      </el-row>
	      <el-row class="inputs">
	          <el-col :span="2" :offset="10">
                <el-button type="default" class="btn_regist" v-on:click="backLong">取 消</el-button>
	          </el-col>
              <el-col :span="12">
                  <el-button type="primary" class="btn_regist" v-on:click="onSubmit">确定找回</el-button>
              </el-col>
	      </el-row>
    </el-form>
	</div><!-- forgetpwd END -->
    <div class="bottom_login">
      <div class="bl_nav">
        <router-link :to="{ path: '/centerIntroduce'}">中心简介</router-link>
        <router-link :to="{ path: '/centerNews'}">新闻资讯</router-link>
        <router-link :to="{ path: '/borrowProcess'}">业务流程</router-link>
        <router-link :to="{ path: '/borrowProject'}">借贷大厅</router-link>
        <router-link :to="{ path: '/policiesRegulations'}">政策法规</router-link>
        <router-link :to="{ path: '/cooperativePartner'}">合作伙伴</router-link>
        <router-link :to="{ path: '/recruitment'}">招贤纳士</router-link>
        <router-link :to="{ path: '/lawStatement'}">法律申明</router-link>
        <router-link :to="{ path: '/contactUs'}">联系我们</router-link>
        <router-link :to="{ path: '/centerAnswer'}">中心问答</router-link>
      </div>
      <div class="copyright">
        Copyright &copy; 2018 陕西普惠投融信息服务有限公司 版权所有 <a href="http://www.miitbeian.gov.cn" target="_blank">陕ICP备18010605号</a>
      </div>
    </div>

    </div>
</template>
<script>
    import {reqForgetPwdCaptcha,reqGoChangePwd} from '../api/webUser-api'
    export default {
        data () {
            return {
                btntxt: '获取验证码',
                showCaptchaCodeButton: false,
                countDownTime: 0,
                form: {
                    phoneNumber: '',
                    phoneCaptcha: '',
                    onlyPhoneCode: '',
                },
              forgetPasswordRules:{
                phoneNumber: [
                  {required: true, message: '请输入手机号', trigger: 'blur'},
                ],
                phoneCaptcha: [
                  {required: true,message: '请输入验证码', trigger: 'blur'},
                ],
              }
            }
        },
        methods: {
          gobackFirstPage:function () {
            this.$store.dispatch('showHF');
            this.$router.push({path:'/'});
          },
  //      获取手机验证码
            getForgetPwdCaptcha () {
                this.form.phoneCaptcha='';
                let para = Object.assign({}, this.form)
                if(para.phoneNumber===''||para.phoneNumber===null){
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                }else {
                      reqForgetPwdCaptcha(para).then((res) => {
                        if(res.data.code===1){
                          this.$message({
                            message: "短信验证码发送成功",
                            type: 'success'
                          });
                          this.form.onlyPhoneCode=res.data.data;
                          this.showCaptchaCodeButton = true;
                          this.countDownTime = 120;
                          this.timer()
                        } else if(res.data.code===2){
                          this.$message({
                            message: "短信验证码发送失败",
                            type: 'error'
                          });
                        }else if(res.data.code===3){
                          this.$message({
                            message:"短信验证码发送异常",
                            type: 'error'
                          });
                        }else if(res.data.code===4){
                          this.$message({
                            message:"该手机号未绑定账号",
                            type: 'error'
                          });
                          this.form.phoneNumber='';
                        }
                      })
                }

            },
            timer: function () {
                if (this.countDownTime > 0) {
                    this.countDownTime--;
                    this.btntxt = this.countDownTime + 'S'
                    setTimeout(this.timer, 1000)
                } else {
                    this.countDownTime = 0
                    this.btntxt = '获取验证码'
                    this.showCaptchaCodeButton = false
                }
            },
            // 取消按钮返回login页面
            backLong(){
                this.$router.push({name:'login'});
            },
            onSubmit(){
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$message({
                            message: '请填写符合规则的信息',
                            type: 'warning'
                        });
                        return false;
                    }
                  this.$refs.form.validate((valid) => {
                    if (valid) {
                      let para = Object.assign({}, this.form);
                      reqGoChangePwd(para).then((res) => {
                        if (res.data.code === 4) {
                          this.$message({
                            message: '验证码失效',
                            type: 'warning'
                          });
                        }else if(res.data.data===2){
                          this.$message({
                            message: '验证成功，请您重新设置密码',
                            type: 'success'
                          });
                          this.$router.push({path: 'changePwd',query: {phoneNumber: this.form.phoneNumber}})
                          console.info("==========phoneNumber"+this.form.phoneNumber);
                        }else if(res.data.code===3){
                          this.$message({
                            message: '验证码错误',
                            type: 'warning'
                          });
                          this.form.phoneCaptcha='';
                        }
                      })
                    }
                  });

                    //=========校验
                }).catch(() => {
                });
            }
        },
        mounted(){
            this.$store.dispatch('hideHF');
        }
    }
</script>
<style>
    .transparent {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>



// WEBPACK FOOTER //
// src/components/ToForgetPwd.vue